import { Form, PageWrap } from "@vwfs-bronson/bronson-react";
import { ContractType } from "../components/question-4/ContractType";
import { AnnuallyKm } from "../components/question-4/AnnuallyKm";
import { Services } from "../components/question-4/Services";
import { WizardButtons } from "../components/ui/WizardButtons";
import { Formik } from "formik";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { Step, SubmitAnswersRequest } from "../interfaces";
import { SaveAndContinue } from "../components/save-and-continue/SaveAndContinue";

export const Question4Page = () => {
    const { submitAnswersRequest, setSubmitAnswersRequest, isEdit } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;

    return (
        <>
            <Formik
                initialValues={{
                    contractType: matchMakerAnswers?.contractType ?? undefined,
                    kmsPerYear: matchMakerAnswers?.kmsPerYear ?? undefined,
                    services: matchMakerAnswers?.services ?? undefined,
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            matchMakerAnswers: {
                                ...matchMakerAnswers,
                                ...values,
                            },
                            isEditMode: isEdit,
                            currentStep: Step.MM4,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps) => (
                    <Form id="Question4PageForm" onSubmit={formikProps.handleSubmit}>
                        <PageWrap
                            size="small"
                            style={{
                                padding: "2rem 0 8rem 0",
                            }}
                        >
                            <ContractType />
                            <hr className="u-mv-large" />
                            <AnnuallyKm />
                            <hr className="u-mv-large" />
                            <Services />
                        </PageWrap>
                        <WizardButtons />
                    </Form>
                )}
            </Formik>
            <SaveAndContinue/>
        </>
    );
};
